import { httpClient } from '../client';
import { ServiceAddonMapping } from '../../../types/service';
import { logger } from '../../../utils/logger';
import { BaseEndpoint } from './base.endpoint';

class ServiceAddonMappingEndpoints extends BaseEndpoint {
  private static instance: ServiceAddonMappingEndpoints;

  private constructor() {
    super('organisations');
  }

  static getInstance(): ServiceAddonMappingEndpoints {
    if (!ServiceAddonMappingEndpoints.instance) {
      ServiceAddonMappingEndpoints.instance = new ServiceAddonMappingEndpoints();
    }
    return ServiceAddonMappingEndpoints.instance;
  }

  async createAddonMapping(organizationId: string, serviceId: number, serviceAddonId: number) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.post<{ data: ServiceAddonMapping }>(
        `${this.basePath}/${organizationId}/serviceaddon`,
        { serviceId, serviceAddonId },
        { headers }
      );

      logger.info('Service addon mapping created successfully');
      return response.data.data;
    } catch (error) {
      logger.error('Failed to create service addon mapping:', error);
      throw error;
    }
  }

  async deleteAddonMapping(organizationId: string, mappingId: number) {
    try {
      const headers = await this.getAuthHeaders();
      await httpClient.delete(`${this.basePath}/${organizationId}/serviceaddon/${mappingId}`, {
        headers,
      });

      logger.info('Service addon mapping deleted successfully');
    } catch (error) {
      logger.error('Failed to delete service addon mapping:', error);
      throw error;
    }
  }
}

export const serviceAddonMappingEndpoints = ServiceAddonMappingEndpoints.getInstance();
